export default "__VITE_ASSET__f1d9c517__"